<template>
  <div class="imageSlider grid grid__item_span-12 p0 m0">

    <div v-if="item.slider_sub_paragraph !== ''" class="text" >
      <div v-if="item.slider_sub_paragraph !== ''" class="grid__item_span-12">
        <p v-if="item.slider_sub_heading" class="grid__item_span-12">{{item.slider_sub_heading}}</p>
        <p v-if="item.slider_paragraph" class="grid__item_span-12 txtCharcol">{{item.slider_paragraph}}</p>
      </div>
      <div class="grid__item_span-10 slide-text" v-for="(images, index) in item.porject_slider_images" :id="'text-'+index" :class="{ 'active': index === 0 }">
        <div v-html="images.paragraph"></div>
      </div>
    </div>

    <div id="rightWrap">

      <div class="slideContainer">

        <div class="slideWrapper">

          <div v-for="(images, index) in item.porject_slider_images" :id="index" class="slide" :class="{ 'active': index === 0 }">

            <img v-for="image in images" class="" :src="image.url" :alt="image.alt" :title="image.title" />

          </div>

        </div>

        <div id="nextBtn" class="swiper-button-next" slot="button-next" @click="initSlide('next', index)"></div>
        <div id="prevBtn" class="swiper-button-prev circle-border" slot="button-prev" @click="initSlide('previous', index)" style="opacity:0.3;"></div>

      </div>

      <div class="slideThumbs">
        <div class="slideWrapper thumbs">

          <div v-for="(images, index) in item.porject_slider_images" :id="'thumb-'+index"  class="thumb" :class="{ 'active': index === 1 }">
            <img v-for="image in images" class="" :src="image.url" :alt="image.alt" :title="image.title" />
          </div>

        </div>
      </div>

    </div>

  </div>

</template> 

<script>

// swiper
// require('swiper/dist/css/swiper.css')
// import {swiper, swiperSlide} from 'vue-awesome-swiper'
import projectSlider from '../../assets/js/projectSlider.js'
import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'ImageSlider',
  props: [
    'item',
    'index'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
     /* swiperOptionTop: { // connecting with slider / settings and transitions
        initialSlide: 0,
        slidesPerView: 1,
        speed: 500,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        centeredSlides: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazyLoading: true
      },
      swiperOptionThumbs: {
        notNextTick: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      } */
    }
  },
  methods: {
    initSlide (direction, index) {
      // console.log(direction + ', ' + index)
      projectSlider.initSlide(direction, index)
    },
    prevSlide (done) {
      projectSlider.prevSlide(done)
    },
    animateElements () {
      animateScroll.animate('rightWrap')
    }
  },
  mounted () {
    var thumbs = document.getElementsByClassName('thumbs')
    for (var a; a < thumbs.length; a++) {
      if (thumbs[a].classList.contains('active')) {
        console.log('yay')
      }
    }
    // var nextSlide = document.getElementsByClassName('next')
    // var nextImage = nextSlide[0].getElementsByTagName('img')[0].getAttribute('src')
    // thumb.getElementsByTagName('img')[0].setAttribute('src', nextImage)
  },
  components: {
   // swiper,
   // swiperSlide
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/imageSlider.vue